import { actions } from './action'

const initialState = {
  toggle: true,
  pagination: {
    skip: 0,
    limit: 10,
  },
  searchedEmp: null,
  empList: {},
  empData: {},
  resignationList: {},
  agentList: {},
  loading: false,
  docType: [],
  canDocType: [],
  genderOptions: [],
  qualificationOptions: [],
  bloodGroupOptions: [],
  empDesignation: [],
  empRole: [],
  empProcess: [],
  department: [],
  agentStatus: 2,
  empRegStatus: 0,
  trainingForTypes: [],
  trainerList: [],
  empfilter: [],
  emp: [],
  empDropdown: [],
}

const onToggle = (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_SWITCH:
      return {
        ...state,
        toggle: action.payload,
      }
    case actions.HANDLE_SEARCH:
      return {
        ...state,
        searchedEmp: action.payload,
      }
    case actions.GET_AGENT_STATUS:
      return {
        ...state,
        agentStatus: action.payload,
      }
    case actions.HANDLE_REG_STATUS:
      return {
        ...state,
        empRegStatus: action.payload,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.GET_EMP_LIST:
      return {
        ...state,
        empList: action.payload,
      }
    case actions.GET_AGENT_LIST:
      return {
        ...state,
        agentList: action.payload,
      }

    case actions.GET_RESIGNATION_LIST:
      return {
        ...state,
        resignationList: action.payload,
      }
    case actions.GET_AGENT_HISTORY:
      return {
        ...state,
        agentHistory: action.payload,
      }
    case actions.RESET_AGENT_HISTORY:
      return {
        ...state,
        agentHistory: [],
      }
    case actions.TOGGLE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case actions.HANDLE_EMP_DESIGNATION:
      return {
        ...state,
        empDesignation: action.payload,
      }
    case actions.HANDLE_DOC_TYPE:
      return {
        ...state,
        docType: action.payload,
      }
    case actions.HANDLE_CAN_DOC_TYPE:
      return {
        ...state,
        canDocType: action.payload,
      }
    case actions.HANDLE_GENDER_OPTIONS:
      return {
        ...state,
        genderOptions: action.payload,
      }
    case actions.HANDLE_QUALIFICATION_OPTIONS:
      return {
        ...state,
        qualificationOptions: action.payload,
      }
    case actions.HANDLE_BLOOD_GROUP_OPTIONS:
      return {
        ...state,
        bloodGroupOptions: action.payload,
      }
    case actions.HANDLE_USER_ROLE:
      return {
        ...state,
        empRole: action.payload,
      }
    case actions.HANDLE_USER_PROCESS:
      return {
        ...state,
        empProcess: action.payload,
      }
    case actions.GET_DEPARTMENT:
      return {
        ...state,
        department: action.payload,
      }
    case actions.FETCH_TRAINING_FOR:
      return {
        ...state,
        trainingForTypes: action?.payload,
      }
    case actions.FETCH_EMPLOYEE_DATA:
      return {
        ...state,
        empData: action?.payload,
      }
    case actions.GET_TRAINER_LIST:
      return {
        ...state,
        trainerList: action.payload,
      }
    case actions.GET_EMP_LIST_IN_DOCS:
      return {
        ...state,
        empfilter: action.payload,
      }
    case actions.GET_EMP_LIST_IN_DOCUMENT:
      return {
        ...state,
        emp: action.payload,
      }
    case actions.GET_EMP_LIST_IN_EMP:
      return {
        ...state,
        empDropdown: action.payload,
      }
    default:
      return state
  }
}
export default onToggle
